
import React, { Suspense, lazy } from 'react';
import styles from './MainContent.module.css';
// import HomeDashBoard from '../HomeDashBoard/HomeDashBoard';
import PreLoader from '../../Components/PreLoader/PreLoader';

// external dependencies
import { Routes, Route, Navigate } from 'react-router-dom';
import AllNotifications from '../../Components/AllNotifications/AllNotifications';
import ActivitiesNotification from '../../Components/ActivitiesNotification/ActivitiesNotification';
import NewDeviceNotification from '../../Components/NewDeviceNotification/NewDeviceNotification';

const HomeDashBoard = lazy(()=> import('../HomeDashBoard/HomeDashBoard'));
const Settings = lazy(()=> import('../Settings/Settings'));
const Investment = lazy(()=> import('../Investment/Investment'));
const Notifications = lazy(()=> import('../Notifications/Notifications'));
const MessageBodyFormat = lazy(()=> import('../../Components/MessageBodyFormat/MessageBodyFormat'));
const Guidelines = lazy(()=> import('../../Components/Guidelines/Guidelines'));
const Support = lazy(()=> import('../Support/Support'));
const WithdrawalActivities = lazy(()=> import('../../Screen/Withrawal_Activities/Withrawal_Activities'));
const PendingActivities = lazy(()=> import('../../Screen/PendingActivities/PendingActivities'));
const ReceivedActivities  = lazy(()=> import('../../Screen/ReceivedActivities/ReceivedActivities'));

const MainContent = ({ profileData })=>{


    return(<section className={styles.MainContent_wrapper}>
        
        <main>
            <Suspense fallback={ <PreLoader /> }>
                <Routes>
                        <Route path='/' element={ <Navigate to={'/dashboard'} />} />
                        <Route path="dashboard/withdrawal_activities" element={<WithdrawalActivities /> } />
                        <Route path="dashboard/pending_activities" element={ <PendingActivities /> } />
                        {/* <Route path="dashboard/received_activities  element={ <ReceivedActivities /> } /> */}
                        <Route path='dashboard/received_activities' element={ <ReceivedActivities profileData={profileData}/> } />
                        {/* /dashboard/received_activities */}
                    <Route path='dashboard/' element={ <HomeDashBoard profileData={profileData} /> }>
                    </Route>
                    <Route path='settings' element={ <Settings profileData={profileData}/> } />
                    <Route path='invest' element={ <Investment profileData={profileData}/> } />
                    <Route path='support' element={ <Support /> } />
                    
                    {/* sub routes */}
                    {/* <Suspense fallback={<h1 style={{fontSize:'40px', color:'red'}}>loading</h1>}> */}
                        <Route path='settings/guidelines' element={ <Guidelines /> } />
                    {/* </Suspense> */}

                    {/* review later */}
                    <Route path='notifications/all_msgs/mesage-content' element={ <MessageBodyFormat profileData={profileData}/> } />
                    <Route path='notifications/activities/mesage-content' element={ <MessageBodyFormat profileData={profileData}/> } />
                    <Route path='/notifications/devices/mesage-content' element={ <MessageBodyFormat profileData={profileData}/> } />

                    <Route path='notifications' element={ <Navigate to={'/notifications/all_msgs'} /> } />
                    <Route path='notifications' element={ <Notifications /> } >
                        <Route path='all_msgs' index element={ <NewDeviceNotification profileData={profileData} /> } />
                        <Route path='activities' element={ <ActivitiesNotification /> } />
                        <Route path='devices' element={ <AllNotifications /> } />
                    </Route>

                    {/* 404 page */}
                    <Route path='*' element={ <h3 style={{
                        position:'absolute',
                        left:'50%',
                        top:'50%',
                        transform:'translate(-50%, -50%)'
                    }}>404 page</h3> } />
                </Routes>
            </Suspense>
        </main>
        
    </section>)
}

export default MainContent;